import React, { Component } from "react";
import { Link } from "react-router-dom";

import Spinner from "../../../components/Library/Spinner";
import Subscribe from "../../../components/Library/Subscribe";

import styles from "./SubscriptionsList.css";

class SubscriptionsList extends Component {
  render() {
    const { subscriptions } = this.props;
    if (!subscriptions.results || (subscriptions.results.length === 0 && subscriptions.isLoading))
      return <Spinner/>;

    return (
      <div>
        <ul className={styles.root}>
          {subscriptions.results.map((subscription, index) => (
            <li key={subscription.id}>
              <div className={styles.category}>{subscription.category}</div>
              <div className={styles.content}>
                <Link to={`/newsletters/${subscription.slug}`} className={styles.name}>{subscription.name}</Link>
                <Subscribe light className={styles.subscribe} subscription={subscription} source={this.props.source} />
              </div>
              <div className={styles.description}>{subscription.description}</div>
              {subscriptions.results.length - 1 !== index && <hr className={styles.separator} aria-hidden={true}/>}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default SubscriptionsList;
